import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { CodesLayout, RefrencesLayout } from "../Layout";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
function UserDefinedTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
        const handleCodesFormLoad = useCallback(() => {
        }, []);
        const handleRefrencesFormLoad = useCallback(() => {
    
        }, []);
    return (
            <TabPanel height={"auto"}>
                <TabItem title="Codes">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='BAA23D38-CE84-438E-8F43-B3D89F470F13'
                        layoutName='WMLotDataEntryUserDefinedCodeForm'
                        defaultFormSchema={CodesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={props.handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={handleCodesFormLoad}
                        handleSelectedItemChange={props.handleSelectionChange}
                    />
                </TabItem>
                <TabItem title="References">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='8A924DC2-9496-44EA-9CDB-DACFB4716050'
                        layoutName='WMLotDataEntryUserDefinedRefForm'
                        defaultFormSchema={RefrencesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={props.handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={handleRefrencesFormLoad}
                        handleSelectedItemChange={props.handleSelectionChange}
                    />
                </TabItem>
            </TabPanel>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UserDefinedTab);